(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/tipsen-shared/assets/javascripts/transform-signs.js') >= 0) return;  svs.modules.push('/components/sport/tipsen-shared/assets/javascripts/transform-signs.js'); "use strict";

const {
  signIndexToOutcome,
  outcomeToSignIndex
} = svs.components.sport.tipsenShared;

const convertSignsTo1X2 = signs => {
  const outcomes = [];

  for (let x = 0; x < signs.length; ++x) {
    outcomes[x] = '';

    for (let i = 0; i < signs[x].length; ++i) {
      if (signs[x][i]) {
        outcomes[x] += signIndexToOutcome[i];
      }
    }
  }

  return outcomes;
};

const convert1X2ToSigns = boardData => boardData.map(outcomeText => {
  const signs = [false, false, false];
  outcomeText.toUpperCase().split('').forEach(sign => {
    signs[outcomeToSignIndex[sign]] = true;
  });
  return signs;
});

setGlobal('svs.components.sport.tipsenShared.transformSigns', {
  convertSignsTo1X2,
  convert1X2ToSigns
});
 })(window);